/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Dropdown } from '@fluentui/react';
import { getTargetConstraints } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import config from '@bingads-webui-component-legacy/config/index';

import { getChooseAdsPanelStyles } from '../styles';

function isTargetHasValue(deal, targetType) {
  return getTargetConstraints(deal, targetType).mandatory.length > 0;
}

export function DealFilterBar(props) {
  const {
    i18n, deals, onFilter, locationFilterOptions, isEnabledDealsV2,
  } = props;

  const classes = useDefaultStyles(getChooseAdsPanelStyles);
  // alphabetical order by location
  const locationOptions = _.sortBy(locationFilterOptions, item => item.text);
  const [ronFilter, setRonFilter] = useState(false);
  const [ageFilter, setAgeFilter] = useState(false);
  const [genderFilter, setGenderFilter] = useState(false);
  const [genreFilter, setGenreFilter] = useState(false);

  const currentLocation = config.get('CurrentUser').Market;
  // For deal V2 SI test, we will remove it when we can fetch US deals from V2 api
  const currentLocationInOptions = locationFilterOptions.find(location => location.key === currentLocation);
  const usLocationOptions = locationFilterOptions.find(location => location.key === 'US');
  const defaultLocationOptions = isEnabledDealsV2 ? _.first(locationFilterOptions) : usLocationOptions;

  const [locationFilter, setLocationFilter] = useState(currentLocationInOptions || defaultLocationOptions);

  function applyFilterToDeal() {
    let tmpDeals = deals.slice();
    if (ronFilter) {
      tmpDeals = tmpDeals.filter(deal =>
        _.get(deal, 'Name', '').toLowerCase().includes('top10') ||
        (!deal.Genre && !deal.AgeRange && !isTargetHasValue(deal, 'Gender') && !isTargetHasValue(deal, 'Device') && !isTargetHasValue(deal, 'Audience')));
    }

    if (ageFilter) {
      tmpDeals = tmpDeals.filter(deal => deal.AgeRange);
    }

    if (genderFilter) {
      tmpDeals = tmpDeals.filter(deal => isTargetHasValue(deal, 'Gender'));
    }

    if (genreFilter) {
      tmpDeals = tmpDeals.filter(deal => deal.Genre);
    }

    if (locationFilter.key !== 'all') {
      tmpDeals = tmpDeals.filter((deal) => {
        const { mandatory } = getTargetConstraints(deal, 'Location');
        return mandatory.includes(String(locationFilter.data.Id));
      });
    }

    onFilter(tmpDeals);
  }

  useEffect(() => {
    applyFilterToDeal();
  }, [ronFilter, ageFilter, genderFilter, genreFilter, locationFilter]);

  function onLocationChange(ev, item) {
    setLocationFilter(item);
  }

  function onRonClick() {
    setRonFilter(!ronFilter);

    setAgeFilter(false);
    setGenderFilter(false);
    setGenreFilter(false);
  }

  function onAgeClick() {
    setAgeFilter(!ageFilter);

    setRonFilter(false);
    setGenderFilter(false);
    setGenreFilter(false);

    applyFilterToDeal();
  }

  function onGenderClick() {
    setGenderFilter(!genderFilter);

    setRonFilter(false);
    setAgeFilter(false);
    setGenreFilter(false);

    applyFilterToDeal();
  }

  function onGenreClick() {
    setGenreFilter(!genreFilter);

    setRonFilter(false);
    setAgeFilter(false);
    setGenderFilter(false);

    applyFilterToDeal();
  }

  return (
    <div className={classes.dealFilterBar} >
      <div className="targetFilters" >
        <div
          onClick={onRonClick}
          className={classnames('target', ronFilter && 'target-active')}
        >
          {i18n.getString(_TL_('RON and TOP10'))}
        </div>
        <div
          onClick={onAgeClick}
          className={classnames('target', ageFilter && 'target-active')}
        >
          {i18n.getString(_TL_('Age'))}
        </div>
        <div
          onClick={onGenderClick}
          className={classnames('target', genderFilter && 'target-active')}
        >
          {i18n.getString(_TL_('Gender'))}
        </div>
        <div
          onClick={onGenreClick}
          className={classnames('target', genreFilter && 'target-active')}
        >
          {i18n.getString(_TL_('Genre'))}
        </div>
      </div>

      <div className="location" >
        <Dropdown
          placeholder={i18n.getString(_TL_('Select a location'))}
          options={locationOptions}
          selectedKey={locationFilter.key}
          onChange={onLocationChange}
          styles={{ dropdown: { width: 200 } }}
        />
      </div>
    </div>
  );
}

DealFilterBar.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  deals: PropTypes.array.isRequired,
  onFilter: PropTypes.func.isRequired,
  locationFilterOptions: PropTypes.array.isRequired,
  isEnabledDealsV2: PropTypes.bool,
};

DealFilterBar.defaultProps = {
  isEnabledDealsV2: false,
};
